export default (builder) =>
  builder.query({
    query: (org) => ({
      url: `scraper/jobs?org=${org}`,
      method: 'GET',
    }),
  });
